import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import {
  getCandidateOffLimitsCompaniesOptions,
  getCandidateOffLimitsIdentitiesOptions,
  getPeopleAdvisorsOptions,
} from 'client/@tanstack/react-query.gen';

const schema = z.object({
  formType: z
    .enum(['networking', 'personal', 'professional'])
    .optional()
    .catch(undefined),
});

export const Route = createFileRoute(
  '/_private/_route/_internal/people/$identityId/_candidate/profile/',
)({
  loader: async ({ context }) => {
    const { queryClient } = context;
    const pAdvisors = queryClient.ensureQueryData(
      getPeopleAdvisorsOptions({
        query: {
          // TODO: Implement pagination so we can change results size and navigate
          // between pages
          size: 100,
        },
      }),
    );
    const pOffLimitCompanies = queryClient.ensureQueryData(
      getCandidateOffLimitsCompaniesOptions({
        path: {
          candidate_uuid: context.candidate.uuid,
        },
      }),
    );
    const pOffLimitPeople = queryClient.ensureQueryData(
      getCandidateOffLimitsIdentitiesOptions({
        path: {
          candidate_uuid: context.candidate.uuid,
        },
      }),
    );
    await Promise.all([pAdvisors, pOffLimitCompanies, pOffLimitPeople]);
  },
  validateSearch: schema,
});
